(function () {
  const LETTER_SIZES = ["XXXS","XXS","XS","S","M","L","XL","XXL","XXXL","4XL","5XL","6XL"];
  const DONE_ATTR = "data-size-sort-done";

  function norm(v) {
    return String(v || "").trim().toUpperCase();
  }

  function parseMonths(text) {
    const t = norm(text);
    let m = t.match(/(\d+)\s*-\s*(\d+)\s*MONTHS?/);
    if (m) return { group: 0, a: Number(m[1]), b: Number(m[2]), raw: text };
    m = t.match(/(\d+)\s*MONTHS?/);
    if (m) return { group: 0, a: Number(m[1]), b: Number(m[1]), raw: text };
    return null;
  }

  function parseYears(text) {
    const t = norm(text);
    let y = t.match(/(\d+)\s*-\s*(\d+)\s*YEARS?/);
    if (y) return { group: 1, a: Number(y[1]), b: Number(y[2]), raw: text };
    y = t.match(/(\d+)\s*YEARS?/);
    if (y) return { group: 1, a: Number(y[1]), b: Number(y[1]), raw: text };
    return null;
  }

  function parseLetter(text) {
    const last = norm(text).split(/\s+/).pop();
    const idx = LETTER_SIZES.indexOf(last);
    if (idx !== -1) return { group: 2, a: idx, b: 0, raw: text };
    return null;
  }

  function sortKey(text) {
    return parseMonths(text) || parseYears(text) || parseLetter(text) || { group: 9, a: 0, b: 0, raw: text };
  }

  function looksLikeSizeSelect(selectEl) {
    const opts = Array.from(selectEl.querySelectorAll("option"))
      .map(o => (o.textContent || "").trim())
      .filter(Boolean);

    let hits = 0;
    for (const txt of opts) {
      const k = sortKey(txt);
      if (k.group === 0 || k.group === 1 || k.group === 2) hits++;
      if (hits >= 2) return true;
    }
    return false;
  }

  function sortSelect(selectEl) {
    const options = Array.from(selectEl.querySelectorAll("option"));
    const placeholder = options.find(o => !o.value);
    const real = options.filter(o => o.value);

    real.sort((a, b) => {
      const ak = sortKey(a.textContent);
      const bk = sortKey(b.textContent);

      if (ak.group !== bk.group) return ak.group - bk.group;
      if (ak.a !== bk.a) return ak.a - bk.a;
      if (ak.b !== bk.b) return ak.b - bk.b;

      return String(ak.raw).localeCompare(String(bk.raw));
    });

    selectEl.innerHTML = "";
    if (placeholder) selectEl.appendChild(placeholder);
    real.forEach(o => selectEl.appendChild(o));
  }

  function getFitLabel(selectEl) {
    const host = selectEl.closest("product-variants");
    if (!host) return "";
    return (host.getAttribute("data-fit-label") || "").trim();
  }

  function applyFitPrefix(selectEl) {
    const fit = getFitLabel(selectEl);
    if (!fit) return;

    const fitLower = fit.toLowerCase();

    Array.from(selectEl.querySelectorAll("option"))
      .filter(o => o.value)
      .forEach(o => {
        const current = (o.textContent || "").trim();
        if (!current) return;

        const lower = current.toLowerCase();
        if (lower.startsWith(fitLower + " ")) return;

        const last = norm(current).split(/\s+/).pop();
        const isLetter = LETTER_SIZES.includes(last);
        const isMonths = /MONTHS?/i.test(current);
        const isYears = /YEARS?/i.test(current);

        if (isLetter || isMonths || isYears) {
          o.textContent = fit + " " + current;
        }
      });
  }

  function runOnce() {
    const pv = document.querySelector("product-variants");
    if (!pv) return;

    pv.querySelectorAll("select").forEach(sel => {
      if (!looksLikeSizeSelect(sel)) return;

      const fit = getFitLabel(sel);

      const stateKey = (fit || "") + "|" + Array.from(sel.options).map(o => o.textContent).join("§");
      const prev = sel.getAttribute(DONE_ATTR);

      if (prev === stateKey) return;

      sortSelect(sel);
      applyFitPrefix(sel);

      const newKey = (fit || "") + "|" + Array.from(sel.options).map(o => o.textContent).join("§");
      sel.setAttribute(DONE_ATTR, newKey);
    });
  }

  let scheduled = false;
  function scheduleRun() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      runOnce();
    });
  }

  function init() {
    if (!document.documentElement.classList.contains("template-product")) {
      if (!location.pathname.includes("/products/")) return;
    }

    scheduleRun();

    const pv = document.querySelector("product-variants");
    if (!pv) return;

    pv.addEventListener("change", scheduleRun, { passive: true });

    const obs = new MutationObserver(() => scheduleRun());
    obs.observe(pv, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
